import { useState } from 'react';
import { AMLRiskScoringTypes, RiskScoringTypes } from '../types';
import RiskScoringContent from './risk-scoring-content';
import { OrganizationType } from '../../../../hoc/common/types';

const IndividualRiskScoring = ({
  aml,
  monthlyTurnover,
  countries,
  blockCollapsed,
  clientsActivities,
  deliveryChannels,
  products,
  sourcesOfFunds,
  riskScoreRanges,
}: AMLRiskScoringTypes) => {
  const [expandedRows, setExpandedRows] = useState<string[]>([
    RiskScoringTypes.DELIVERY_CHANNEL,
    RiskScoringTypes.GEOGRAPHICAL_RISK,
    RiskScoringTypes.PRODUCTS,
    RiskScoringTypes.TYPE_OF_CLIENT,
    RiskScoringTypes.SOURCE_OF_FUNDS,
    RiskScoringTypes.MONTHLY_VOLUMES,
  ]);

  const onExpandClick = () => {
    if (expandedRows.length) {
      setExpandedRows([]);
    } else {
      setExpandedRows([
        RiskScoringTypes.DELIVERY_CHANNEL,
        RiskScoringTypes.GEOGRAPHICAL_RISK,
        RiskScoringTypes.PRODUCTS,
        RiskScoringTypes.TYPE_OF_CLIENT,
        RiskScoringTypes.SOURCE_OF_FUNDS,
        RiskScoringTypes.MONTHLY_VOLUMES,
      ]);
    }
  };

  return (
    <RiskScoringContent
      blockCollapsed={blockCollapsed}
      onExpandClick={onExpandClick}
      expandedRows={expandedRows}
      type={OrganizationType.INDIVIDUAL}
      setExpandedRows={setExpandedRows}
      aml={aml}
      countries={countries}
      clientsActivities={clientsActivities}
      deliveryChannels={deliveryChannels}
      products={products}
      sourcesOfFunds={sourcesOfFunds}
      monthlyTurnover={monthlyTurnover}
      riskScoreRanges={riskScoreRanges}
    />
  );
};

export default IndividualRiskScoring;
